<template>
  <div class="projectConfig">
    <el-card shadow="never">{{ projectName }}</el-card>
    <div class="content">
      <el-form ref="formData" :inline="true" :rules="rules" :model="formData" label-width="130px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="项目编号" prop="projectId">
              <el-input v-model="formData.projectId" clearable style="width: 240px;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="项目名称" prop="projectName">
              <el-input v-model="formData.projectName" clearable style="width: 240px;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="使用方名称" prop="owner">
              <el-input v-model="formData.owner" clearable style="width: 240px;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="使用方类型" prop="manufacturerType">
              <el-select v-model="formData.manufacturerType" clearable style="width: 240px;">
                <el-option v-for="(item, index) in manufacturerTypeList" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="项目地点" prop="locationStr">
              <el-input v-model="formData.locationStr" clearable style="width: 200px;"></el-input>
              <el-button type="primary" icon="el-icon-map-location" circle size="small"
                         @click="mapLocation()"></el-button>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="项目坐标" prop="location">
              <el-input v-model="formData.location" clearable style="width: 240px;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="产品类型" prop="productType">
              <el-select v-model="formData.productType" clearable style="width: 240px;">
                <el-option v-for="(item, index) in productTypeList" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电池类型" prop="batteryType">
              <el-select v-model="formData.batteryType" clearable style="width: 240px;">
                <el-option v-for="(item, index) in batteryTypeList" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电池厂商" prop="batteryManufacturers">
              <el-select v-model="formData.batteryManufacturers" clearable style="width: 240px;">
                <el-option v-for="(item, index) in batteryManufacturersList" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="项目状态" prop="status">
              <el-select v-model="formData.status" clearable style="width: 240px;">
                <el-option v-for="(item, index) in statusList" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否显示" prop="isShow">
              <el-select v-model="formData.isShow" clearable style="width: 240px;">
                <el-option v-for="(item, index) in isShowList" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="储能功率" prop="energyStoragePower">
              <el-input v-model="formData.energyStoragePower" clearable style="width: 240px;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="储能容量" prop="energyStorageCapacity">
              <el-input v-model="formData.energyStorageCapacity" clearable style="width: 240px;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="充电桩总容量	" prop="chargingPileCapacity">
              <el-input v-model="formData.chargingPileCapacity" clearable style="width: 240px;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="光伏容量" prop="solarCapacity">
              <el-input v-model="formData.solarCapacity" clearable style="width: 240px;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="变压器容量" prop="transformerCapacity">
              <el-input v-model="formData.transformerCapacity" clearable style="width: 240px;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="投运时间" prop="startTime">
              <el-date-picker v-model="formData.startTime" class="datePickerClass" value-format="yyyy-MM-dd HH:mm:ss"
                              type="datetime" placeholder="选择日期时间" style="width: 240px;"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电价组合" prop="priceId">
              <el-select v-model="formData.priceId" clearable style="width: 170px;">
                <el-option v-for="(item, index) in priceIdList" :key="index" :label="item.priceName"
                           :value="item.id"></el-option>
              </el-select>
              <el-button type="primary" icon="el-icon-plus" circle size="small" @click="openDrawer('add')"></el-button>
              <el-button type="warning" icon="el-icon-edit" circle size="small" @click="openDrawer('edit')"></el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="场景配置" prop="sceneType">
              <el-select v-model="formData.sceneType" clearable style="width: 240px;">
                <el-option v-for="(item, index) in sceneTypeList" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订阅数据源" prop="subscribeSource">
              <el-select v-model="formData.subscribeSource" style="width: 240px;">
                <el-option v-for="(item, index) in subscribeSourceList" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="投资方名称" prop="subscribeSource">
              <el-input v-model="formData.investor" clearable style="width: 240px;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="用户类型" prop="electricityType">
              <el-select v-model="formData.electricityType" placeholder="请选择用电类别" style="width: 240px;">
                <el-option v-for="(item,index) in useElecList" :key="index" :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="产品数量" prop="productNum">
              <el-input v-model="formData.productNum" type="Number" placeholder="请输入产品数量" clearable
                        style="width: 240px;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="并网点数量" prop="parallelBranchNum">
              <el-input v-model="formData.parallelBranchNum" type="Number" placeholder="请输入并网点数量" clearable
                        style="width: 240px;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="系统类型" prop="systemType">
              <el-select v-model="formData.systemType" placeholder="请选择系统类型" style="width: 240px;">
                <el-option v-for="(item,index) in systemTypeList" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电网接入数量" prop="accessPointCount">
              <el-input v-model="formData.accessPointCount" type="Number" placeholder="请输入电网接入数量" clearable
                        style="width: 240px;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="PCS类型" prop="systemType">
              <el-select v-model="formData.pcsType" placeholder="请选择PCS类型" style="width: 240px;">
                <el-option v-for="(item,index) in pcsTypeList" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="text-align: center;">
          <el-form-item>
            <el-button class="btn" type="primary" @click="saveFormData()" style="margin-top: 20px;">保存</el-button>
          </el-form-item>
        </el-row>
      </el-form>

    </div>
    <!-- 电价组合-->
    <el-drawer title="电价组合" :visible.sync="drawer" direction="rtl" size="50%" :before-close="handleClose"
               :append-to-body="true">
      <el-form ref="formPrice" :inline="true" :model="formPrice" style="margin: 10px;">
        <el-card shadow="never">
          <el-form-item label="电价名称">
            <el-input v-model="formPrice.priceName"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="formPrice.note" type="textarea" :rows="2"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="clearAllData">清空全部</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addProjectPriceInfo(tablePriceData)">保存全部</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addOnePrice">新增一行</el-button>
          </el-form-item>
        </el-card>
      </el-form>
      <div style="margin: 10px;">
        <el-table :data="tablePriceData" border style="width: 100%;margin-top: 10px;">
          <el-table-column prop="type" label="电价类型">
            <template slot-scope="{ row }">
              <div>
                <el-select v-model="row.kind">
                  <el-option v-for="item in kindOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="峰谷类型">
            <template slot-scope="{ row }">
              <div>
                <el-select v-model="row.type">
                  <el-option v-for="item in peekptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="电价">
            <template slot-scope="{ row }">
              <div>
                <el-input v-model.number="row.price" type="Number"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="startmonth" label="开始月份">
            <template slot-scope="{ row }">
              <div>
                <el-select v-model="row.startmonth">
                  <el-option v-for="item in 12" :key="item" :label="item + '月'" :value="item"></el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="endmonth" label="结束月份">
            <template slot-scope="{ row }">
              <div>
                <el-select v-model="row.endmonth">
                  <el-option v-for="item in 12" :key="item" :label="item + '月'" :value="item"></el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="starttime" label="开始时间">
            <template slot-scope="{ row }">
              <div>
                <el-select v-model="row.starttime">
                  <el-option v-for="(item, index) in 25" :key="index" :label="index + '点'" :value="index"></el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="endtime" label="结束时间">
            <template slot-scope="{ row }">
              <div>
                <el-select v-model="row.endtime">
                  <el-option v-for="(item, index) in 25" :key="index" :label="index + '点'" :value="index"></el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="{ row }">
              <el-button class="btn" size="small" icon="el-icon-delete" @click="deleteProjectPrice(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>
    <!-- 项目地点和坐标 -->
    <Dialog ref="locationDialog" title="项目地点" dlgWidth="60%">
      <div id="container" style="width: 100%;height: 500px;"></div>
      <div id="myPageTop">
        <table>
          <tr>
            <td>
              <label>请输入关键字：</label>
            </td>
          </tr>
          <tr>
            <td>
              <el-input id="tipinput" v-model="tipinput" clearable size="mini" style="margin-top: 5px;" />
            </td>
          </tr>
        </table>
      </div>
      <div id="panel"></div>
      <div style="margin-top: 10px;">
        <span>地点：{{locationName}}</span>
        <span style="margin-left: 50px;">经度：{{locationLng}}</span>
        <span style="margin-left: 50px;">纬度：{{locationLat}}</span>
      </div>
      <template slot="footer">
        <el-button type="primary" @click="onSubmit()">确定</el-button>
      </template>
    </Dialog>
  </div>
</template>

<script>
import PROJECTAPI from '@/api/project';
import GROUPAPI from '@/api/group';
import Dialog from '@/components/dialog';
export default {
  props: {
    projectName: {
      type: [String, Number]
    },
    projectId: {
      type: [String, Number]
    },
    isType: {
      type: [String, Number]
    }
  },
  data() {
    return {
      loading: false,
      drawerTitle: '',
      emsData: [],
      tableDeviceData: [], //设备表
      tableData: [], //数据点表
      deviceTypeOptions: [], //设备类型
      deviceScenarioOptions: [], //场景类型
      dataOptions: [], //场景类型
      dataPointOptions: [], //数据点类型
      currentSn: '', //当前的sn节点
      currentDevice: '', //当前的设备
      currentEdit: '', //当前的编辑类型
      currentDeviceType: '', //设备类型id
      formSn: {}, //实体表单
      formDevice: {}, //设备表单
      formData: {}, //数据点表单
      formExcel: {}, //excel表单
      fileList: [],
      accept: '.xls, .xlsx',
      deviceTableHeight: 416,
      productTypeList: [],
      statusList: [],
      batteryTypeList: [],
      systemTypeList: [], //系统类型
      pcsTypeList:[
        {id:9,name:'集中式PCS'},
        {id:15,name:'多支路PCS'}
      ],
      isShowList: [{
        id: 0,
        name: "无权访问"
      }, {
        id: 1,
        name: "显示"
      }],
      batteryManufacturersList: [],
      manufacturerTypeList: [],
      priceIdList: [],
      sceneTypeList: [{
        id: 1,
        name: '2D'
      }, {
        id: 2,
        name: '3D'
      }],
      subscribeSourceList: [{
        id: 'emsdata_mqtt',
        name: 'emsdata_mqtt'
      }, {
        id: 'emsdatav2',
        name: 'emsdatav2'
      }],
      formPrice: {},
      kindOptions: [],
      peekptions: [],
      tablePriceData: [],
      drawer: false,
      map: null,
      marker: [],
      locationName: '',
      locationLng: '',
      locationLat: '',
      tipinput: '',
      hotspot: {},
      markers: [],
      hotspotoverEvent: null,
      markerClickEvent: null,
      searchTimer: null,
      hotspotTimer: null,
      rules: {
        productNum: [{
          required: true,
          message: '请输入产品数量',
          trigger: 'blur'
        }],
        parallelBranchNum: [{
          required: true,
          message: '请输入并网点数量',
          trigger: 'blur'
        }],
        systemType: [{
          required: true,
          message: '请选择系统类型',
          trigger: 'blur'
        }]
      },
      useElecList: [{
        label: '未定义',
        value: 0
      }, {
        label: '大工业（≥315KVA)',
        value: 1
      },
        {
          label: '一般工商业 （普通工业）',
          value: 2
        },
        {
          label: '一般工商业（普通工业除外）',
          value: 3
        },
        {
          label: '一般工商业（地铁）',
          value: 4
        },
        {
          label: '一般工商业（非工业用电）',
          value: 5
        },
        {
          label: '一般工商业（商业）',
          value: 6
        },
        {
          label: '一般工商业（普通工业除外）',
          value: 7
        },
        {
          label: '一般工商业（普通工业专变）',
          value: 8
        },
        {
          label: '一般工商业 （商业、非工业、非专变普通工业）',
          value: 9
        },
        {
          label: '居民用户',
          value: 10
        },
        {
          label: '合表用户',
          value: 11
        }
      ]
    };
  },
  components: {
    Dialog
  },
  created() {
    this.formSn.projectId = this.projectId;
    this.getSwitchSearchCodes(1);   // 获取电池类型
    this.getSwitchSearchCodes(2);   // 获取电池厂商
    this.getSwitchSearchCodes(4);   // 获取产品类型
    this.getSwitchSearchCodes(7);   // 获取使用方类型
    this.getSwitchSearchCodes(17);  // 获取峰谷类型
    this.getSwitchSearchCodes(24);  // 获取电价类型
    this.getSwitchSearchCodes(25);  // 项目状态
    this.getSwitchSearchCodes(29);  // 系统类型
    if (this.isType != 'add') {
      this.searchProjectDetail(this.projectId);
    }
  },
  beforeDestroy() {
    this.destroyMap();
  },
  watch: {
    tipinput(val) {
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
      if (val != "") {
        this.removeHotspotoverListener();
        if (this.markers.length > 0) {
          this.markers.forEach((item) => {
            this.map.remove(item);
          })
        }
        let that = this;
        this.searchTimer = setTimeout(function() {
          that.placeSearch.search(val, function(status, result) {
            if (status === 'complete' && result.poiList) {
              var pois = result.poiList.pois;
              if (!pois || pois.length === 0) return;
              var markers = [];
              for (var i = 0; i < pois.length; i++) {
                var poi = pois[i];
                markers[i] = new AMap.Marker({
                  position: poi.location, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                  title: poi.name
                });
                // 将创建的点标记添加到已有的地图实例：
                that.map.add(markers[i]);
                markers[i].on('click', function() {
                  if (that.hotspot.poiList && that.hotspot.poiList.pois && that.hotspot.poiList.pois.length > 0) {
                    that.locationName = that.hotspot.poiList.pois[0].pname + that.hotspot.poiList.pois[0]
                        .cityname + that.hotspot.poiList.pois[0].adname + that.hotspot.poiList.pois[0].address +
                      that.hotspot.poiList.pois[0].name;
                    that.locationLng = that.hotspot.poiList.pois[0].location.lng;
                    that.locationLat = that.hotspot.poiList.pois[0].location.lat;
                  }
                });
              }
              that.markers = markers;
              that.map.setFitView();
            }
          })
        }, 500);
      } else {
        this.hotspotoverFun();
      }
    }
  },
  methods: {
    //获取电价接口
    searchProjectPriceInfo() {
      PROJECTAPI.searchProjectPriceInfo().then(res => {
        if (res.data.code) {
          this.priceIdList = res.data.data
        }
      })
    },
    searchProjectDetail(projectId) {
      let params = {
        projectId: projectId
      }
      PROJECTAPI.searchProjectDetail(params).then(res => {
        if (res.data.code == 200) {
          this.formData = res.data.data;
        }
      });
    },
    beforUpload(file) {
      this.loading = true;
      const formdata = new FormData();
      formdata.append('files', file);
      formdata.append('projectId', this.projectId);
      formdata.append('emsId', this.currentSn);
      formdata.append('equipType', this.formExcel.equipType);
      let self = this;
      PROJECTAPI.importExcelsForProjectData(formdata)
        .then(res => {
          if (res.data.code == 200) {
            self.$message.success('操作成功');
            self.formExcel = {}
            self.drawer = false;
            self.loading = false;
            self.searchProjectEquipmentInfo();
            return true;
          }
        }).catch(() => {
        self.loading = false;
      })
      return false;
    },
    handleRemove(file, fileList) {
    },
    handlePreview(file) {
    },
    //获取selected的name值
    getSelectedName(val, arr, key, name) {
      return this.COMM.getTypeOptions(val, arr, key, name);
    },
    //获取码表数据
    getSwitchSearchCodes(number) {
      let self = this;
      let params = {
        codesType: number
      };
      GROUPAPI.searchCodes(params).then(res => {
        if (res.data.code == 200) {
          switch (number) {
            case 1: {
              self.batteryTypeList = res.data.data;
              break;
            }
            case 2: {
              self.batteryManufacturersList = res.data.data;
              break;
            }
            case 4: {
              self.productTypeList = res.data.data;
              break;
            }
            case 7: {
              self.manufacturerTypeList = res.data.data;
              break;
            }
            case 17: {
              // 0平值、1峰值、2谷值、3尖值
              self.peekptions = [{
                id: 0,
                name: '平值'
              }, {
                id: 1,
                name: '峰值'
              }, {
                id: 2,
                name: '谷值'
              }, {
                id: 3,
                name: '尖值'
              }];
              break;
            }
            case 24: {
              //电价类型0市电电价1备电电价2充电桩电价
              this.searchProjectPriceInfo()
              self.kindOptions = [{
                id: 0,
                name: '市电电价'
              }, {
                id: 1,
                name: '备电电价'
              }, {
                id: 2,
                name: '充电桩电价'
              }];
              break;
            }
            case 25: {
              self.statusList = res.data.data;
              break;
            }
            case 29: {
              self.systemTypeList = res.data.data;
              break
            }
          }
        }
      });
    },
    //查询数据点码表类型
    searchFieldsCodes(number) {
      let params = {
        codesId: number,
        fieldsCodesType: 0
      };
      GROUPAPI.searchFieldsCodes(params).then(res => {
        if (res.data.code == 200) {
          this.dataPointOptions = res.data.data;
        }
      });
    },
    //点击ems
    clickEms(row) {
      this.formSn = row;
      this.currentSn = row.emsId;
      this.currentDevice = '';
      //查询对应的设备
      this.searchProjectEquipmentInfo();
    },
    //点击表行选中
    rowClick(row, column, event) {
      this.$refs.tableDeviceData.setCurrentRow(row);
      this.formDevice = row;
      this.currentDevice = row.equipId;
      this.currentDeviceType = row.type;
      //获取数据点类型
      this.searchFieldsCodes(this.currentDeviceType);
      //查询数据点列表
      this.searchProjectEquipmentFieldsInfo();
    },
    //打开编辑侧单
    // openDrawer(flag, row) {
    //   if (flag == 'sn') {
    //     if (!row) {
    //       this.drawerTitle = '添加SN';
    //       this.formSn = {};
    //       this.formSn.projectId = this.projectId;
    //     } else {
    //       this.drawerTitle = '修改SN';
    //       this.formSn = row;
    //       this.currentSn = row.emsId;
    //     }
    //   } else if (flag == 'dev') {
    //     if (!row) {
    //       this.drawerTitle = '添加设备';
    //       this.formDevice = {};
    //       this.formDevice.projectId = this.projectId;
    //       this.formDevice.emsId = this.currentSn;
    //     } else {
    //       this.drawerTitle = '修改设备';
    //       this.formDevice = row;
    //       this.currentDevice = row.equipId;
    //     }
    //   } else if (flag == 'data') {
    //     if (!row) {
    //       this.drawerTitle = '添加数据点';
    //       this.formData = {};
    //       this.formData.projectId = this.projectId;
    //       this.formData.emsId = this.currentSn;
    //       this.formData.equipId = this.currentDevice;
    //     } else {
    //       this.drawerTitle = '修改数据点';
    //       this.formData = row;
    //     }
    //   } else if (flag == 'excel') {
    //     this.drawerTitle = '导入EXCEL';
    //     this.fileList = [];
    //     this.formExcel.projectId = this.projectId;
    //     this.formExcel.emsId = this.currentSn;
    //     if (!this.formExcel.emsId) {
    //       this.$message.warning('请选择SN数据！');
    //       return false;
    //     }
    //   }
    //   //设置编辑标记
    //   this.currentEdit = flag;
    //   this.drawer = true;
    // },
    //保存ems实体
    saveFormSn() {
      let params = JSON.parse(JSON.stringify(this.formSn));
      if (params.emsId) {
        PROJECTAPI.updateProjectEms(params).then(res => {
          if (res.data.code == 200) {
            this.$message.success('操作成功');
            this.drawer = false;
            this.searchProjectEms();
          }
        });
      } else {
        PROJECTAPI.addProjectEms(params).then(res => {
          if (res.data.code == 200) {
            this.$message.success('操作成功');
            this.drawer = false;
            this.searchProjectEms();
          }
        });
      }
    },
    //保存设备
    saveFormDevice() {
      let params = JSON.parse(JSON.stringify(this.formDevice));
      if (params.equipId) {
        PROJECTAPI.updateProjectEquipmentInfo(params).then(res => {
          if (res.data.code == 200) {
            this.$message.success('操作成功');
            this.drawer = false;
            this.searchProjectEms();
          }
        });
      } else {
        PROJECTAPI.addProjectEquipmentInfo(params).then(res => {
          if (res.data.code == 200) {
            this.$message.success('操作成功');
            this.drawer = false;
            this.searchProjectEquipmentInfo();
          }
        });
      }
    },
    //保存数据点数据
    saveFormData() {
      let params = JSON.parse(JSON.stringify(this.formData));
      if (this.isType == 'edit') {
        PROJECTAPI.updateProjectV2(params).then(res => {
          if (res.data.code == 200) {
            this.$message.success('操作成功');
            this.drawer = false;
            // this.searchProjectEquipmentFieldsInfo();
          }
        });
      } else if (this.isType == 'add') {
        PROJECTAPI.addProjectV2(params).then(res => {
          if (res.data.code == 200) {
            this.$message.success('操作成功');
            this.drawer = false;
            this.searchProjectDetail(this.formData.projectId);
            let addProjectObj = {
              projectId: this.formData.projectId,
              projectName: this.formData.projectName
            };
            this.$emit('addProjectObj', addProjectObj);
            this.$emit('dataType', 'edit');
          }
        });
      }
    },
    //保存表单
    saveFormExcel() {
      if (!this.formExcel.equipType) {
        this.$message.warning('请选择设备类型');
        return false;
      }
      this.$refs.upload.submit();
    },
    //项目数据点导入-查询项目设备实体列表
    searchProjectEquipmentInfo() {
      let params = {
        projectId: this.projectId,
        emsId: this.currentSn
      };
      PROJECTAPI.searchProjectEquipmentInfo(params).then(res => {
        if (res.data.code == 200) {
          this.tableDeviceData = res.data.data;
        }
      });
    },
    //查询实体信息列表
    searchProjectEms() {
      let params = {
        projectId: this.projectId
      };
      PROJECTAPI.searchProjectEms(params).then(res => {
        if (res.data.code == 200) {
          this.emsData = res.data.data;
        }
      });
    },
    //查询数据点列表
    searchProjectEquipmentFieldsInfo() {
      let params = {
        projectId: this.projectId,
        equipId: this.currentDevice
      };
      PROJECTAPI.searchProjectEquipmentFieldsInfo(params).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data;
        }
      });
    },
    //关闭
    handleClose(done) {
      done();
    },
    mapLocation() {
      this.$refs.locationDialog.open();
      this.tipinput = '';
      if (document.getElementById("panel")) {
        document.getElementById("panel").innerHTML = "";
      }
      this.$nextTick(() => {
        this.initMap();
      });
    },
    removeHotspotoverListener() {
      if (this.hotspotoverEvent) {
        window.AMap.event.removeListener(this.hotspotoverEvent);
        this.hotspotoverEvent = null;
      }
    },
    removeMarkerClickListener() {
      if (this.markerClickEvent) {
        window.AMap.event.removeListener(this.markerClickEvent);
        this.markerClickEvent = null;
      }
    },
    destroyMap() {
      this.removeHotspotoverListener();
      this.removeMarkerClickListener();
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
      if (this.hotspotTimer) {
        clearTimeout(this.hotspotTimer);
        this.hotspotTimer = null;
      }
      if (this.map) {
        this.map.destroy();
        this.map = null;
      }
      this.marker = [];
      this.markers = [];
      this.placeSearch = null;
    },
    initMap() {
      if (this.map) {
        this.destroyMap();
      }
      var map = new AMap.Map("container", {
        resizeEnable: true,
        isHotspot: true
      });
      this.map = map;
      let _this = this;
      let locationName = "";
      map.on('click', function(e) {
        if (_this.marker.length > 0) {
          _this.marker.forEach((item) => {
            map.remove(item);
          })
        }
        if (_this.markers.length > 0) {
          _this.markers.forEach((item) => {
            map.remove(item);
          })
        }
        if (_this.hotspot.poiList && _this.hotspot.poiList.pois && _this.hotspot.poiList.pois.length > 0) {
          _this.locationName = _this.hotspot.poiList.pois[0].pname + _this.hotspot.poiList.pois[0].cityname +
            _this.hotspot.poiList.pois[0].adname + _this.hotspot.poiList.pois[0].address + _this.hotspot.poiList
              .pois[0].name;
          _this.locationLng = _this.hotspot.poiList.pois[0].location.lng;
          _this.locationLat = _this.hotspot.poiList.pois[0].location.lat;
          let marker = new AMap.Marker({
            position: _this.hotspot.poiList.pois[0].location, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          });
          _this.marker.push(marker);
          map.add(marker);
        } else {
          _this.locationName = locationName;
          _this.locationLng = e.lnglat.lng;
          _this.locationLat = e.lnglat.lat;
          let marker = new AMap.Marker({
            position: e.lnglat, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          });
          _this.marker.push(marker);
          map.add(marker);
        }
      });
      this.hotspotoverFun();
      //输入提示
      var autoOptions = {
        input: "tipinput"
      };
      var auto = new AMap.Autocomplete(autoOptions);
      this.placeSearch = new AMap.PlaceSearch({
        // pageSize: 5, // 单页显示结果条数
        // pageIndex: 1, // 页码
        citylimit: false, //是否强制限制在设置的城市内搜索
        map: map, // 展现结果的地图实例
        // panel: "panel", // 结果列表将在此容器中进行展示。
        autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
      });
      //构造地点查询类
      AMap.event.addListener(auto, "select", this.select); //注册监听，当选中某条记录时会触发
    },
    hotspotoverFun() {
      let _this = this;
      this.hotspotoverEvent = window.AMap.event.addListener(
        _this.map,
        "hotspotover",
        result => {
          if (_this.hotspotTimer) {
            clearTimeout(_this.hotspotTimer);
          }
          _this.hotspotTimer = setTimeout(function() {
            _this.placeSearch.getDetails(result.id, function(status, result) {
              if (status === 'complete' && result.info === 'OK') {
                _this.hotspot = result;
              }
            });
          }, 300);
        }
      )
    },
    select(e) {
      this.placeSearch.setCity(e.poi.adcode);
      this.placeSearch.search(e.poi.name);  // 关键字查询查询
      let _this = this;
      this.removeMarkerClickListener();
      this.markerClickEvent = AMap.event.addListener(this.placeSearch, 'markerClick', function(e) {
        _this.locationName = e.data.pname + e.data.cityname + e.data.adname + e.data.address + e.data.name;
        _this.locationLng = e.data.location.lng;
        _this.locationLat = e.data.location.lat;
      })
    },
    onSubmit() {
      this.$refs.locationDialog.close();
      this.formData.locationStr = this.locationName;
      this.formData.location = this.locationLng + "," + this.locationLat;
    },
    //新增电价组合
    openDrawer(row) {
      this.formPrice = {};
      if (row == 'edit') {
        //实体反选
        this.priceIdList.forEach(item => {
          if (this.formData.priceId == item.id) {
            this.formPrice = item;
          }
        });
        //电价反选
        this.searchProjectPrice(this.formData.priceId, true);
      } else {
        this.tablePriceData = [];
        this.drawer = true;
      }
    },
    //查看电价列表
    searchProjectPrice(priceId, flag) {
      let params = {
        priceId: priceId
      };
      PROJECTAPI.searchProjectPrice(params).then(res => {
        if (res.data.code == 200) {
          this.tablePriceData = res.data.data;
          if (flag) {
            this.drawer = true;
          }
        }
      });
    },
    //清空所有数据
    clearAllData() {
      this.tablePriceData = [];
    },
    //项目列表-新增电价组合实体
    addProjectPriceInfo(tablePriceData) {
      let self = this;
      let params = this.formPrice;
      PROJECTAPI.addProjectPriceInfo(params).then(res => {
        if (res.data.code == 200) {
          if (res.data.data) {
            //生成的实体赋值为编辑状态
            self.formPrice.id = res.data.data.id;
          }
          tablePriceData = tablePriceData.map(item => {
            item.priceId = res.data.data.id;
            return item;
          });
          if (tablePriceData.length > 0) {
            PROJECTAPI.updateBatchProjectPrice(tablePriceData).then(data => {
              self.$message.success('操作成功');
              self.searchProjectPrice(res.data.data.id);
            });
          }
          self.getSwitchSearchCodes(24);
        }
      });
    },
    addOnePrice() {
      var obj = {};
      let has = false;
      let self = this;
      this.tablePriceData.forEach(item => {
        if (item.price == '' || item.price == undefined) {
          has = true;
        }
      });
      if (!has) {
        let index = self.tablePriceData.length + 1;
        obj.index = index;
        self.tablePriceData.push(obj);
      } else {
        this.$message.warning('请完善数据信息！');
      }
    },
    //删除电价列表数据
    deleteProjectPrice(row) {
      if (row.index) {
        this.tablePriceData.splice(row.index - 1, 1);
        return;
      }
      let params = {
        priceId: row.id
      };
      let self = this;
      this.$confirm('确定要执行此操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          PROJECTAPI.deleteProjectPrice(params).then(res => {
            self.searchProjectPrice(row.priceid);
          });
        })
        .catch(() => {});
    },
  }
};
</script>

<style lang="scss">
.projectConfig {
  .el-card__header {
    font-weight: bold;
    background: #f0f2f5;
    text-align: center;
  }

  .content {
    padding: 30px;
  }

  .el-date-editor.datePickerClass.el-input.el-input--medium .el-input__inner {
    padding-left: 15px !important;
  }

  .el-button+.el-button {
    margin-left: 0px;
  }

  .el-dialog--center .el-dialog__body {
    padding: 0px;

    .content {
      padding: 10px 20px;
    }
  }

  .button-group {
    position: absolute;
    bottom: 20px;
    right: 20px;
    font-size: 12px;
    padding: 10px;
  }

  .button-group .button {
    height: 28px;
    line-height: 28px;
    background-color: #0D9BF2;
    color: #FFF;
    border: 0;
    outline: none;
    padding-left: 5px;
    padding-right: 5px;
    border-radius: 3px;
    margin-bottom: 4px;
    cursor: pointer;
  }

  .button-group .inputtext {
    height: 26px;
    line-height: 26px;
    border: 1px;
    outline: none;
    padding-left: 5px;
    padding-right: 5px;
    border-radius: 3px;
    margin-bottom: 4px;
    cursor: pointer;
  }

  #tip {
    background-color: #fff;
    padding-left: 10px;
    padding-right: 10px;
    position: absolute;
    font-size: 12px;
    right: 10px;
    top: 20px;
    border-radius: 3px;
    border: 1px solid #ccc;
    line-height: 30px;
  }

  .amap-info-content {
    font-size: 12px;
  }

  #myPageTop {
    position: absolute;
    top: 70px;
    left: 40px;
    background: #fff none repeat scroll 0 0;
    border: 1px solid #ccc;
    margin: 10px auto;
    padding: 6px;
  }

  #myPageTop label {
    margin: 0 20px 0 0;
    color: #666666;
    font-weight: normal;
    font-family: "Microsoft Yahei", "微软雅黑", "Pinghei";
    font-size: 14px;
  }

  #myPageTop input {
    width: 170px;
  }

  #myPageTop .column2 {
    padding-left: 25px;
  }

  #panel {
    position: absolute;
    background-color: white;
    max-height: 90%;
    overflow-y: auto;
    top: 80px;
    right: 30px;
    width: 280px;
  }
}
</style>
<style lang="scss">
.amap-sug-result {
  z-index: 999999 !important;
}

.amap-copyright {
  opacity: 0 !important;
}

.amap-logo {
  display: none;
  opacity: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/boss/project/projectConfig.vue